import type { AxiosResponse } from 'axios';
import { LoginActionTypes } from './actionTypes';
import type {
  LoginFailed,
  LoginSucceeded,
  LogoutFailed,
  LogoutRequest,
  LogoutSucceeded,
  SessionRequest,
  UpdateAccountFailed,
  UpdateAccountSucceeded,
  UserFleetChangeRequest,
  UserInfoUpdateRequest,
} from './actions';

import type { AccessibleFleet, Session } from '@cobliteam/common-types';

import type { UserInfoUpdateRequestAPI } from '@cobliteam/api-lib';

export const loginSucceeded = (session: Session, attributes?: any): LoginSucceeded => ({
  type: LoginActionTypes.LOGIN_SUCCEEDED,
  payload: {
    session,
    attributes,
  },
});

export type LoginError = AxiosResponse<{ error_code: string; hubspot_jwt?: string }> | undefined;
export const loginFailed = (errorMessage?: string, data?: LoginError): LoginFailed => ({
  type: LoginActionTypes.LOGIN_FAILED,
  errorMessage,
  data,
});

export const logoutSucceeded = (): LogoutSucceeded => ({
  type: LoginActionTypes.LOGOUT_SUCCEEDED,
});

export const logoutRequest = (): LogoutRequest => ({
  type: LoginActionTypes.LOGOUT_REQUEST,
});

export const logoutFailed = (): LogoutFailed => ({
  type: LoginActionTypes.LOGOUT_FAILED,
});

export const sessionRequest = (): SessionRequest => ({
  type: LoginActionTypes.SESSION_REQUEST,
});

export const updateAccountRequest = (updates: UserInfoUpdateRequestAPI): UserInfoUpdateRequest => ({
  type: LoginActionTypes.UPDATE_ACCOUNT_REQUEST,
  payload: updates,
});

export const updateAccountSucceeded = (session: Session): UpdateAccountSucceeded => ({
  type: LoginActionTypes.UPDATE_ACCOUNT_SUCCEEDED,
  payload: session,
});

export const updateAccountFailed = (): UpdateAccountFailed => ({
  type: LoginActionTypes.UPDATE_ACCOUNT_FAILED,
});

export const changeUserFleetRequest = (userFleet: AccessibleFleet): UserFleetChangeRequest => ({
  type: LoginActionTypes.CHANGE_USER_FLEET_REQUEST,
  payload: userFleet,
});
